const getIdNumber = item => item.attr('id').replace('generic-step__item-', '');

const nextStep = ($form) => {
  const currentSign = $('.generic-step__item--active');
  const nextSign = currentSign.next();
  const current = $(`#generic-step-${getIdNumber(currentSign)}`);

  if (nextSign) {
    const next = $(`#generic-step-${getIdNumber(nextSign)}`);
    currentSign.addClass('generic-step__item--passed');
    nextSign.addClass('generic-step__item--active');

    current.fadeOut(() => {
      next.hide().removeClass('hidden');
      next.fadeIn(() => $form.enableClientSideValidations());
    });
  }
};

const callNextStepIfIsValidStep = ($form, validators) => {
  if ($form.isValid(validators)) {
    nextStep($form);
  } else {
    $form.resetClientSideValidations();
  }
};

export {
  nextStep,
  callNextStepIfIsValidStep
};



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/components/step.js